<div class="component-main-container">
  <div class="header">
    <app-page-header parentTitle="{{'installation-site.installation-site-parent-label' | translate}}"
      pageTitle="{{'installation-site.installation-site-title-label' | translate}}">
    </app-page-header>
  </div>

  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-register-form></app-register-form>

        <div class="form-fields-box" [ngClass]="!filterInstallationSiteBox ? 'closed' : ''" [formGroup]="filterForm">

          <h2 (click)="filterInstallationSiteOpen()">{{'installation-site.form-filter-label' | translate}}
          </h2>

          <hr [ngClass]="!filterInstallationSiteBox ? 'hr-open' : ''">

          <div class="form-step first">
            <mat-form-field appearance="outline">
              <mat-label>{{'installation-site.form-filter-adress' | translate}}</mat-label>
              <input matInput #filter formControlName="address">
            </mat-form-field>
          </div>

          <div class="row form">
            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-reference' | translate}}</mat-label>
                <input matInput formControlName="reference">
              </mat-form-field>
            </div>

            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-zip-code' | translate}}</mat-label>
                <input matInput mask="00000-000" formControlName="locationCode">
              </mat-form-field>
            </div>

            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-number' |
                  translate}}</mat-label>
                <input matInput type="number" formControlName="number">
              </mat-form-field>
            </div>

            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-street' | translate}}</mat-label>
                <input matInput formControlName="street">
              </mat-form-field>
            </div>

            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-neighborhood' | translate}}</mat-label>
                <input matInput formControlName="district">
              </mat-form-field>
            </div>

            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-city' | translate}}</mat-label>
                <input matInput formControlName="city">
              </mat-form-field>
            </div>

            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-state' | translate}}</mat-label>
                <input matInput formControlName="state">
              </mat-form-field>
            </div>

            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-country' | translate}}</mat-label>
                <input matInput formControlName="country">
              </mat-form-field>
            </div>
          </div>

          <!-- Botões do filtro. -->
          <div class="d-flex m-2">
            @if (!filterInstallationSiteLoading) {
            <button class="btn btn-success m-1 w-50" (click)="filterIntallationSite(null)">
              {{'installation-site.form-filter-button' |
              translate}}
            </button>
            }
            @if (filterForm.valid && !filterInstallationSiteLoading) {
            <button (click)="clearFilter()" class="btn btn-secondary m-1 w-50">
              {{'installation-site.form-register-clean-filter' | translate}}
            </button>
            }
            @if (filterInstallationSiteLoading) {
            <mat-spinner [diameter]="30"></mat-spinner>
            }
          </div>
        </div>

        <div class="form-fields-box" [ngClass]="!registerInstallationSite ? 'closed' : ''" [formGroup]="createForm">

          <h2 (click)="registerInstallationSiteOpen()">{{'installation-site.form-register-label' |
            translate}}
          </h2>

          <hr [ngClass]="!registerInstallationSite ? 'hr-open' : ''">
          <div class="form-step first">
            <mat-form-field appearance="outline">
              <mat-label>{{'installation-site.form-register-adress' | translate}}</mat-label>
              <input matInput #register formControlName="address">
            </mat-form-field>
          </div>

          <div class="row form">
            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-register-reference' |
                  translate}}</mat-label>
                <input matInput formControlName="reference">
              </mat-form-field>
            </div>
            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-register-zip-code' |
                  translate}}</mat-label>
                <input matInput mask="00000-000" formControlName="locationCode">
              </mat-form-field>
            </div>
            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-number' |
                  translate}}</mat-label>
                <input matInput type="number" formControlName="number">
              </mat-form-field>
            </div>
            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-neighborhood' |
                  translate}}</mat-label>
                <input matInput formControlName="district">
              </mat-form-field>
            </div>
            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-state' |
                  translate}}</mat-label>
                <input matInput formControlName="state">
              </mat-form-field>
            </div>
            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-filter-city' |
                  translate}}</mat-label>
                <input matInput formControlName="city">
              </mat-form-field>
            </div>
            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-register-street' |
                  translate}}</mat-label>
                <input matInput formControlName="street">
              </mat-form-field>
            </div>
            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-register-Address-details' |
                  translate}}</mat-label>
                <input matInput formControlName="details">
              </mat-form-field>
            </div>
            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-register-latitude' |
                  translate}}</mat-label>
                <input matInput formControlName="lat">
              </mat-form-field>
            </div>
            <div class="form-step">
              <mat-form-field appearance="outline">
                <mat-label>{{'installation-site.form-register-longitude' |
                  translate}}</mat-label>
                <input matInput formControlName="long">
              </mat-form-field>
            </div>
          </div>

          <div class="d-flex m-2">
            @if (!registerInstallationSiteLoading) {
            <button class="btn btn-success m-1 w-50"
              (click)="checkInputsCreateInstallationSite()">{{'installation-site.form-register-button' |
              translate}}
            </button>
            }

            <button (click)="clearRegister()" class="btn btn-secondary m-1 w-50" [disabled]="createForm.invalid">
              {{'installation-site.form-register-clean-filter' | translate}}
            </button>
            @if (registerInstallationSiteLoading) {
            <mat-spinner [diameter]="30"></mat-spinner>
            }
          </div>
        </div>
      </div>
    </div>

    @if (length > 0) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [loadingData$]="fileLoading" [hasPDF]="true" (downloadCSV)="generateFileData(null,'CSV')"
        (downloadPDF)="generateFileData(null,'PDF')"></app-table-header>
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" [paginator]="true" dataKey="id" [rows]="pageSize" [totalRecords]="length"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true"
          [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="reference">{{'installation-site.column-reference' |
                translate}}
              </th>
              <th pSortableColumn="address" style="width: 2rem">{{'installation-site.column-adress' | translate}}</th>
              <th pSortableColumn="number" style="width: 2rem">{{'installation-site.column-number' | translate}}</th>
              <th pSortableColumn="district" style="width: 1rem">{{'installation-site.column-neighborhood' |
                translate}}</th>
              <th pSortableColumn="city" style="width: 1rem">{{'installation-site.column-city' | translate}}</th>
              <th pSortableColumn="state" style="width: 1rem">{{'installation-site.column-state' | translate}}</th>
              <th pSortableColumn="coordinates" style="width: 1rem">{{'installation-site.column:-coordinates' |
                translate}}</th>
              <th pSortableColumn="actions">{{"installation-site.column-actions" | translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>
                {{row.reference}}
              </td>
              <td>
                {{row.street}}
              </td>
              <td>
                {{row.number}}
              </td>
              <td>
                {{row.district}}
              </td>
              <td>
                {{row.city}}
              </td>
              <td>
                {{row.state}}
              </td>
              <td>
                {{row.lat}} {{row.long}}
              </td>
              <td>
                <p-button (click)="openSidebarUpdate(row, true)" styleClass="btn-actions" [rounded]="true"
                  icon="pi pi-pen-to-square" />
                <p-button (click)="openSidebarUpdate(row, false)" styleClass="btn-view" [rounded]="true"
                  icon="pi pi-eye" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
    @if (sideBarOpen) {
    <div class="sidebar-edit" [formGroup]="updateForm">
      <mat-icon class="component-close-icon" (click)="closeSidebarUpdate()"> clear </mat-icon>
      @if (viewController) {
      <h2 class="title-edit"> {{"installation-site.form-edit-title" | translate}} </h2>
      }
      @if (!viewController) {
      <h2 class="title-edit"> {{"installation-site.form-view-title" | translate}}
      </h2>
      }
      <hr>
      <mat-form-field appearance="outline">
        <mat-label> {{"installation-site.form-edit-adress" | translate}} </mat-label>
        <input matInput #update formControlName="address">
      </mat-form-field>
      <div class="container-flex">
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-street" | translate}} </mat-label>
          <input matInput formControlName="street">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-district" | translate}} </mat-label>
          <input matInput formControlName="district">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-city" | translate}} </mat-label>
          <input matInput formControlName="city">
        </mat-form-field>
      </div>
      <div class="container-flex">
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-reference" | translate}} </mat-label>
          <input matInput [formControl]="reference">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-city" | translate}} </mat-label>
          <input matInput formControlName="city">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-number" | translate}} </mat-label>
          <input matInput type="number" formControlName="number">
        </mat-form-field>
      </div>
      <div class="container-flex">
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-details" | translate}} </mat-label>
          <input matInput [formControl]="details">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-location-code" | translate}} </mat-label>
          <input matInput mask="00000-000" formControlName="locationCode">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-country" | translate}} </mat-label>
          <input matInput formControlName="country">
        </mat-form-field>
      </div>
      <div class="container-flex">
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-state" | translate}} </mat-label>
          <input matInput formControlName="state">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-lat" | translate}} </mat-label>
          <input matInput formControlName="lat">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label> {{"installation-site.form-edit-long" | translate}} </mat-label>
          <input matInput formControlName="long">
        </mat-form-field>
      </div>
      <hr>
      <!-- Aplique um estilo de altura ao container-map para ocupar toda a altura da tela -->
      <div class="full" id="map" #map></div>
      @if (viewController && !filterInstallationSiteLoading) {
      <button (click)="updateInstallationSite()" class="btn btn-success m-1 w-50">
        {{"installation-site.form-edit-button-save" | translate}}
      </button>
      }
      <button [disabled]="!viewController" class="btn btn-danger m-1 w-50" (click)="deleteInstallationSite()">
        {{"installation-site.form-edit-button-delete" | translate}}
      </button>
      @if (filterInstallationSiteLoading) {
      <mat-spinner [diameter]="30"></mat-spinner>
      }
    </div>
    }
  </div>
</div>